import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive } from '@nuxtjs/composition-api';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import CatalogFilterHeader from '~/domains/catalog/components/CatalogFilterHeader.vue';
import CatalogFilterHeaderSorting from '~/domains/catalog/components/CatalogFilterHeaderSorting.vue';
import CatalogFilterHeaderFilters from '~/domains/catalog/components/CatalogFilterHeaderFilters.vue';

interface Props {
  category?: any;
  sorting?: any;
}
interface Emits {
  (e: 'update:sorting', data: Props['sorting']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogLayout',
  props: {
    category: { default: () => ({}) },
    sorting: { default: () => ({}) }
  },
  emits: ["update:sorting"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:sorting', data: Props['sorting']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { category: any, sorting: any };




const { isGreater } = useBreakpoints(breakpointsTailwind);
const showFilters = reactive({
  desktop: true,
  mobile: false,
});

const sortingValue = computed({
  get() {
    return props.sorting;
  },
  set(value) {
    emit('update:sorting', value);
  },
});

const toggleFilters = () => {
  const bp = isGreater('lg') ? 'desktop' : 'mobile';
  showFilters[bp] = !showFilters[bp];
};

return { __sfc: true,props, emit, isGreater, showFilters, sortingValue, toggleFilters, CatalogFilterHeader, CatalogFilterHeaderSorting, CatalogFilterHeaderFilters }
}

})